import { IResourceDetail, Resource, ResourceListQuery } from 'capability-ng-resources';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { SurveyQuery } from '../../queries/survey_query';

export class SurveySummaryContentController {
  constructor(
    private ngSurveyQuery: SurveyQuery,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private loadSurveyResourcesCommand: ICommand,
    private updateSurveyCommand: ICommand,
    private ngResourceListQuery: ResourceListQuery
  ) {}

  $onInit() {
    const surveyID = _4.get(this, 'survey.id');
    const surveyResources = _4.get(this, 'survey.resources');

    if (!_4.isUndefined(surveyID)) {
      this.updateSurveyCommand(surveyID, { status: 'COMPLETED' });
    }

    if (!_4.isEmpty(surveyResources)) {
      this.loadSurveyResourcesCommand(surveyResources);
    }
  }

  get survey() {
    return _4.find(this.ngSurveyQuery.result, (survey) => survey.id === this.$stateParams.surveyID);
  }

  get resources() {
    const surveyResources = _4.get(this, 'survey.resources', []);
    const resourceDetails = this.ngResourceListQuery.result;

    return _4.filter(
      resourceDetails,
      (resource: Resource) => !_4.isEmpty(_4.intersection([resource.id], surveyResources))
    );
  }

  hasResources() {
    return !_4.isEmpty(this.resources);
  }

  completeSurvey() {
    this.$state.go('my.feed', {}, { reload: true });
  }
}

export class SurveySummaryContentComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-survey/src/components/survey_summary_content/survey_summary_content.html';
  public controller: object = SurveySummaryContentController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/components/survey_summary_content/survey_summary_content.ts